import React, {useEffect, useState} from 'react';
import {
  BrowserRouter,
  Route,
  Routes
} from "react-router";

import Privacy from './Privacy'
import Terms from './Terms'
import SetupGuide from './SetupGuide';
import ViewerShop from './ViewerShop';
import InstallApp from './InstallApp';
import {GolfVideo} from './landingPages/GolfVideo';
import {GolfVideo as GolfVideoTest} from './landingPages/GolfVideo.Animated';
import PracticeLoop from './landingPages/PracticeLoop';
import $ from 'jquery';
import LogoText from './components/logoText';
import CricketNew from './landingPages/Cricket-New';
import InstallPromo from './landingPages/InstallPromo';
import {AflKids} from "./landingPages/afl/AflKids";
import {CricketBowlingHome} from "./landingPages/bowling/Cricket-Home";
import {CricketBowlingThrowing} from "./landingPages/bowling/Cricket-Bowling-Throwing";
import {AflElwoodAuskick} from "./landingPages/afl/AflElwoodAuskick";
import { iphoneRedeemCode } from './link-actions';

const App = () => {

    useEffect(() => {
      $('.atf-nav').append('<span class="atf-menu-toggle"><span></span></span>');
      $('.menu-item-has-children').append('<span class="atf-menu-dropdown-toggle"></span>');
      $('.atf-menu-toggle').on('click', function() {
          $(this).toggleClass("atf-toggle-active").siblings('.atf-nav-list').slideToggle();
      });
      $('.atf-menu-dropdown-toggle').on('click', function() {
          $(this).toggleClass('active').siblings('ul').slideToggle();
      });

      $('.atf-onepage-nav a').on('click', function() {
        $('.atf-menu-toggle').toggleClass("atf-toggle-active").siblings('.atf-nav-list').slideToggle();
      });

    });


    return (
      <div className="page-wrapper">
        <header className="atf-site-header atf-style1 atf-sticky-header">
          <div className="atf-main-header">
            <div className="container">
              <div className="atf-main-header-in">

                <div className="atf-main-header-left">
                  <a className="atf-site-branding atf-white-logo" href="/#home">
                      <LogoText light={true} style={{fontSize: '20px'}} />
                  </a>
                </div>

                {1==1 && <div className="atf-main-header-right">
                  <button onClick={() => iphoneRedeemCode("T20WC2026M")} style={{background: "none", border: "none", padding: "0"}}>
                    <div style={{backgroundColor: "yellowgreen", borderRadius: "10px", padding: '7px 10px', textAlign: 'center'}}>
                      <p style={{fontSize: '12px', color: "white", lineHeight: '14px'}}>MASTERS SPECIAL</p>
                      <p style={{fontSize: '11px', color: "white", lineHeight: '16px'}}>30 days free</p>
                    </div>
                  </button>
                  {1==2 &&
                  <div className="atf-nav">
                    <ul className="atf-nav-list atf-onepage-nav">
                      <li><a href="/golf" className="atf-smooth-move">Golf</a></li>
                      <li><a href="/afl" className="atf-smooth-move">AFL</a></li>
                      <li>
                        {(1==1) ?  <a href="/promo"  className="atf-smooth-move page-scroll atf-themes-btn ps-3 pe-3">
                        <div style={{textAlign: 'center'}}>
                          <p style={{fontSize: '18px', color: "white", lineHeight: '22px'}}>Get 90 days free</p>
                          <p style={{fontSize: '12px', color: "white", lineHeight: '20px'}}>US OPEN special. Ends Jun 16.</p>
                        </div>
                      </a> :
                        <a href="#get-started" className="atf-smooth-move page-scroll atf-themes-btn ps-3 pe-3">Try for free</a>
                        }</li>
                    </ul>
                  </div>}
                </div>}
              </div>
            </div>
          </div>
        </header>

        <BrowserRouter>
          <Routes>
            <Route path="/setup.html" element={<SetupGuide />} />
            <Route path="/privacy.html" element={<Privacy />} />
            <Route path="/terms.html" element={<Terms />} />
            <Route path="/viewer-shop" element={<ViewerShop />} />
            <Route path="/install" element={<InstallApp />} />
            <Route path="/promo/:promoCode" element={<InstallPromo />} />
            <Route path="/cricket" element={<CricketBowlingHome />} />
            <Route path="/cricket-throwing" element={<CricketBowlingThrowing />} />
            <Route path="/golf" element={<GolfVideo />} />
            <Route path="/golftest" element={<GolfVideoTest />} />
            <Route path="/afl" element={<AflKids />} />
            <Route path="/elwood" element={<AflElwoodAuskick />} />
            <Route path="/" element={<PracticeLoop />} />
          </Routes>
        </BrowserRouter>
        <Footer></Footer>
      </div>
    )
}

function Footer() {
  return (
    <footer className="atf-footer-area">
      <div className="atf-section-padding pb-0">
        <div className="atf-footer-boottom text-center mt-4">
          <div className="row">
            <div className="col-md-12">
              <p><a style={{ fontSize: '12px' }} href="/">Home</a> | <a style={{ fontSize: '12px' }} href="setup.html">Setup guide</a> | <a style={{ fontSize: '12px' }} href="privacy.html">Privacy policy</a> | <a style={{ fontSize: '12px' }} href="terms.html">Terms of service</a> </p>
              <p style={{ fontSize: '12px' }}>&copy;Copyright - Ormond Code</p>
            </div>
          </div>
        </div>

      </div>
    </footer>
  )
}

export default App;
